/* eslint-disable no-bitwise */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, forwardRef, useEffect } from "react";
import { ChildPropMerger } from "../../../utilities";
import { handleCookies } from "../../../../utils/cookies";
import { handleScript } from "../../../../utils/scripts";
import { handleStorage } from "../../../../utils/storage";
import { Tunnel } from "../../../Tunnel";
import { Contentful } from "../../../Contentful";
import { RemoteComponent } from "../../../RemoteComponent";
import logger, { LapelError } from "../../../../logger";
var TYPES = {
    NONE: 0,
    REMOTE_COMPONENT: 1,
    TUNNEL: 2
};
var JsonRenderer = /*#__PURE__*/ forwardRef(function JsonRenderer(props, ref) {
    var _props_content = props.content, content = _props_content === void 0 ? {} : _props_content, children = props.children, name = props.name, _props_overrideResponseProps = props.overrideResponseProps, overrideResponseProps = _props_overrideResponseProps === void 0 ? {} : _props_overrideResponseProps, renderContentType = props.renderContentType, renderContentfulComponent = props.renderContentfulComponent;
    var tmp = content.props, contentProps = tmp === void 0 ? {} : tmp, tmp1 = content.contentful, contentfulProps = tmp1 === void 0 ? {} : tmp1;
    var cookies = content.cookies, script = content.script, storage = content.storage, tunnel = content.tunnel, component = content.component, remote = content.remote, _content_mergeChildProps = content.mergeChildProps, mergeChildProps = _content_mergeChildProps === void 0 ? true : _content_mergeChildProps;
    // Memoized to trap error in lifecycle
    var override = Boolean(component) * TYPES.REMOTE_COMPONENT | Boolean(tunnel) * TYPES.TUNNEL;
    var requestedCookieValues = useMemo(function() {
        if (cookies) {
            return handleCookies(cookies);
        }
        return {};
    }, [
        cookies
    ]);
    var requestedStorageValues = useMemo(function() {
        if (storage) {
            return handleStorage(storage);
        }
        return {};
    }, [
        storage
    ]);
    useEffect(function() {
        if (script) {
            // fire and forget
            handleScript(script).catch(function(error) {
                logger.error(new LapelError("Remote script " + script.remote + "(" + script.component + ") execution", error));
            });
        }
    });
    var overrideProps = useMemo(function() {
        return _extends({}, overrideResponseProps, contentProps, requestedStorageValues, requestedCookieValues);
    }, [
        overrideResponseProps,
        contentProps,
        requestedCookieValues,
        requestedStorageValues
    ]);
    var mergedChildren = useMemo(function() {
        return ChildPropMerger({
            children: children,
            overrideProps: overrideProps,
            mergeChildProps: mergeChildProps
        });
    }, [
        children,
        overrideProps,
        mergeChildProps
    ]);
    var result = mergedChildren;
    if (contentfulProps && Object.keys(contentfulProps).length > 0) {
        result = /*#__PURE__*/ _jsx(Contentful, {
            contentfulProps: contentfulProps,
            renderContentType: renderContentType,
            renderContentfulComponent: renderContentfulComponent
        });
    }
    if (override & TYPES.REMOTE_COMPONENT) {
        var _mergedChildren;
        result = /*#__PURE__*/ _jsx(RemoteComponent, {
            props: ((_mergedChildren = mergedChildren) == null ? void 0 : _mergedChildren.props) || overrideProps,
            component: component,
            remote: remote,
            ref: ref,
            children: result
        });
    }
    if (override & TYPES.TUNNEL) {
        result = /*#__PURE__*/ _jsx(Tunnel, _extends({}, tunnel, {
            name: name,
            ref: ref,
            children: result
        }));
    }
    return result;
});
export { JsonRenderer };

//# sourceMappingURL=index.js.map